import LinkCTA from '2-core-elements/LinkCTA/LinkCTA';
import DataList from '6-my-mcc/Components/DataList/DataList';
import { useCallback, useMemo, useState, type FC } from 'react';
import FormClubEmailPreferences from './FormClubEmailPreferences';
import type { CommunicationPreferencesFormType } from '../../Utils/useCommunicationPreferencesConfig';
import { pushGTMEvent } from 'utils/eventGTM';

type ClubEmailPreferencesProps = {
    emailPreferencesConfig: {
        config: CommunicationPreferencesFormType;
        value: string | null;
    }[];
    isWaitingListMember: boolean | null;
}

const ClubEmailPreferences: FC<ClubEmailPreferencesProps> = ({ emailPreferencesConfig, isWaitingListMember }) => {
    const [showEditForm, setShowEditForm] = useState<boolean>(false);

    const toogleEditForm = useCallback(() => {
        setShowEditForm(!showEditForm);
    }, [showEditForm]);

    const formFilteredConfig = useMemo((): { config: CommunicationPreferencesFormType; value: string | null}[] => {
        return emailPreferencesConfig.filter(item => {
            if (isWaitingListMember) {
                return item.config.code === 'WaitingListEmails';
            }
            return item.config.code !== 'WaitingListEmails';
        });
    }, [emailPreferencesConfig, isWaitingListMember]);

    return (
        <div className="communication-preferences-panel">
            <div className="communication-preferences-panel-header base-wrapper-header">
                <h2 className="base-wrapper-title">Club Email Preferences </h2>
                <div className="communication-preferences-panel-tools">
                    {showEditForm ? (
                        <LinkCTA
                            size={'sm'}
                            prefixIcon={'close'}
                            aria-label="Cancel edit"
                            type="button"
                            onClick={(): void => {
                                toogleEditForm();
                            }}
                            onlyIcon={true}
                        />
                    ) : (
                        <LinkCTA
                            size={'xs'}
                            suffixIcon={'edit'}
                            aria-label="Edit club email preferences"
                            type="button"
                            onClick={(): void => {
                                toogleEditForm();
                            }}
                        >
                            Edit
                        </LinkCTA>
                    )}
                </div>
            </div>

            {showEditForm && (
                <FormClubEmailPreferences
                    emailPreferencesConfig={formFilteredConfig}
                    onSubmitSuccess={(): void => {
                        toogleEditForm();

                        pushGTMEvent({
                            actionType: 'form_complete',
                            name: 'Club email preferences',
                            type: 'Communication preferences',
                        });
                    }}
                />
            )}

            {!showEditForm && (
                <DataList>
                    {formFilteredConfig.map(item => {
                        return (
                            <DataList.Item
                                key={`club-email-preferences-config-${item.config.code}`}
                                label={item.config.name}
                                value={item.value || 'No'}
                            />
                        );
                    })}
                </DataList>
            )}
        </div>
    );
};

export default ClubEmailPreferences;
